import React, { useEffect, useRef } from "react";
import { Logging } from "@newrelic/browser-agent/src/features/logging";
import { JSErrors } from "@newrelic/browser-agent/src/features/jserrors";
import { useEventContext } from "../../state/events/context";
import { useAuthContext } from "../../state/authentication/context";

const {
	REACT_APP_ENV,
	REACT_APP_NEWRELIC_LICENSE_KEY,
	REACT_APP_NEWRELIC_APPLICATION_ID,
	REACT_APP_NEWRELIC_ACCOUNT_ID,
	REACT_APP_SPORT_ID_METRICS_ENABLED
} = process.env;

// eslint-disable-next-line no-unused-vars
const options = {
	init: {
		session_replay: {
			enabled: false,
			block_selector: "",
			mask_text_selector: "*",
			sampling_rate: 10.0,
			error_sampling_rate: 100.0,
			mask_all_inputs: true,
			collect_fonts: true,
			inline_images: false,
			inline_stylesheet: true,
			fix_stylesheets: true,
			preload: false,
			mask_input_options: {}
		},
		distributed_tracing: { enabled: false },
		privacy: { cookies_enabled: false },
		ajax: { deny_list: ["bam.nr-data.net"] }
	},
	info: {
		beacon: "bam.nr-data.net",
		errorBeacon: "bam.nr-data.net",
		licenseKey: REACT_APP_NEWRELIC_LICENSE_KEY,
		applicationID: REACT_APP_NEWRELIC_APPLICATION_ID,
		sa: 1
	},
	loader_config: {
		accountID: REACT_APP_NEWRELIC_ACCOUNT_ID,
		trustKey: REACT_APP_NEWRELIC_ACCOUNT_ID,
		agentID: REACT_APP_NEWRELIC_APPLICATION_ID,
		licenseKey: REACT_APP_NEWRELIC_LICENSE_KEY,
		applicationID: REACT_APP_NEWRELIC_APPLICATION_ID
	},
	features: [Logging, JSErrors]
};

const NewRelicMetrics = () => {
	const { state: eventState } = useEventContext();
	const currentEvent = eventState.currentEvent();
	const { eventId, sportId } = currentEvent || {};
	const enabledSportIds = REACT_APP_SPORT_ID_METRICS_ENABLED?.split(",") || [];
	const agent = useRef(null);

	const { state } = useAuthContext();

	const profile = state.profile();
	const { username, id: userId } = profile;

	useEffect(() => {
		const [runningAgent] = Object.values(newrelic.initializedAgents || {}) || [];
		if (!runningAgent) {
			if (enabledSportIds.includes(sportId)) {
				import("@newrelic/browser-agent/src/loaders/browser-agent").then(
					({ BrowserAgent }) => {
						agent.current = new BrowserAgent(options);
						//
						agent.current.wrapLogger(console, "error", {
							customAttributes: {
								eventId,
								username,
								userId
							},
							level: "error"
						});

						agent.current.setErrorHandler((err) => {
							if (err?.message?.startsWith("Warning")) {
								return true;
							}

							return false;
						});
					}
				);
			}
		} else {
			runningAgent.setCustomAttribute("sportId", sportId);
			runningAgent.setCustomAttribute("eventId", eventId);
			runningAgent.setCustomAttribute("userId", userId);
			runningAgent.setCustomAttribute("username", username);
		}
		return () => {
			agent.current = null;
		};
	}, [REACT_APP_ENV, sportId, userId]);

	return (
		<div style={{ display: "none" }}>
			NR-AGENT:{agent.current?.runtime?.version || "disabled"}
		</div>
	);
};

export default NewRelicMetrics;
